import ApiService from '@/common/api.service'

export default {
  state: {
    noticesCount: 0,
    canEnroll: true,
    noticesLoaded: false,
  },
  getters: {
    noticesCount: state => state.noticesCount,
  },
  mutations: {
    setNoticesCount(state, data) {
      state.noticesCount = data.notices_count
      state.noticesLoaded = true
      state.canEnroll = data.can_enroll
    },
  },
  actions: {
    getNotices({ commit, state }) {
      return new Promise(resolve => {
        if (state.noticesLoaded) return resolve(state.noticesCount)
        ApiService.query('sms/notices')
          .then(({ data }) => {
            commit('setNoticesCount', data)
            resolve(data.notices_count)
          })
          .catch(err => {
            resolve(null)
          })
      })
    },
  },
}
